import { Contractoptions } from '../../mdqx-graphql-types';
import { isNotNullOrUndefined } from '../../../helper/helper';

export const TEGueltigkeitDauerUnits = [{value: 'd', multiple: 'Tage', single: 'Tag'}, {value: 'y', multiple: 'Jahre', single: 'Jahr'}]
export class ContractOptionsEntity {
    public static readonly GqlFields = `
    casenumber
    contractId
    dtaOptions
    einreichfristNachQuartalEndeInWochen
    hatAnamnese
    id
    istWkv
    kuendigungsfristInTagen
    laufzeitInMonaten
    medizinprodukteEigenleistungErlaubt
    mindestalterVersicherter
    teAnzahlSeiten
    teGueltigkeitId
    teGueltigkeitDauerUnit
    teGueltigkeitDauerValue
    widerrufsfristInTagen`;

    public Casenumber?: string | null;
    public ContractId: number;
    public DtaOptions?: string | null;
    public TEGueltigkeitDauerUnit?: string | null;
    public TEGueltigkeitDauerValue?: number | null;
    public EinreichfristNachQuartalEndeInWochen?: number | null;
    public HatAnamnese?: boolean | null;
    public Id: number;
    public IstWkv?: boolean |null;
    public KuendigungsfristInTagen?: number | null;
    public LaufzeitInMonaten?: number | null;
    public MedizinprodukteEigenleistungErlaubt?: boolean | null;
    public MindestalterVersicherter?: number | null;
    public TeAnzahlSeiten?: number | null;
    public TeGueltigkeitId?: number | null;
    public WiderrufsfristInTagen?: number | null;

    constructor(contractOptionsType: Contractoptions | null) {
        if (
            contractOptionsType &&
            contractOptionsType.casenumber !== undefined &&
            contractOptionsType.contractId != null &&
            contractOptionsType.dtaOptions !== undefined &&
            contractOptionsType.teGueltigkeitDauerUnit !== undefined &&
            contractOptionsType.teGueltigkeitDauerValue !== undefined &&
            contractOptionsType.einreichfristNachQuartalEndeInWochen !== undefined &&
            contractOptionsType.hatAnamnese !== undefined &&
            contractOptionsType.id != null &&
            contractOptionsType.istWkv !== undefined &&
            contractOptionsType.kuendigungsfristInTagen !== undefined &&
            contractOptionsType.laufzeitInMonaten !== undefined &&
            contractOptionsType.medizinprodukteEigenleistungErlaubt !== undefined &&
            contractOptionsType.mindestalterVersicherter !== undefined &&
            contractOptionsType.teAnzahlSeiten !== undefined &&
            contractOptionsType.teGueltigkeitId !== undefined &&
            contractOptionsType.widerrufsfristInTagen !== undefined
        ) {
            this.Casenumber = contractOptionsType.casenumber;
            this.ContractId = contractOptionsType.contractId;
            this.DtaOptions = contractOptionsType.dtaOptions;
            this.TEGueltigkeitDauerUnit = contractOptionsType.teGueltigkeitDauerUnit;
            this.TEGueltigkeitDauerValue = contractOptionsType.teGueltigkeitDauerValue;
            this.EinreichfristNachQuartalEndeInWochen =
                contractOptionsType.einreichfristNachQuartalEndeInWochen;
            this.HatAnamnese = contractOptionsType.hatAnamnese;
            this.Id = contractOptionsType.id;
            this.IstWkv = contractOptionsType.istWkv;
            this.KuendigungsfristInTagen = contractOptionsType.kuendigungsfristInTagen;
            this.LaufzeitInMonaten = contractOptionsType.laufzeitInMonaten;
            this.MedizinprodukteEigenleistungErlaubt =
                contractOptionsType.medizinprodukteEigenleistungErlaubt;
            this.MindestalterVersicherter = contractOptionsType.mindestalterVersicherter;
            this.TeAnzahlSeiten = contractOptionsType.teAnzahlSeiten;
            this.TeGueltigkeitId = contractOptionsType.teGueltigkeitId;
            this.WiderrufsfristInTagen = contractOptionsType.widerrufsfristInTagen;
        } else {
            console.error('received broken ContractOptionsType', contractOptionsType);
            throw Error();
        }
    }
}
